export const myCommunity = {
  'backoffice.myCommunity.genealogyTreeTitle': 'Soy Ağacım',
  'backoffice.myCommunity.organizationalChart': 'Organizasyon Şeması',
  'backoffice.myCommunity.treeViewTitle': 'Ağaç Görünümü',
  'backoffice.myCommunity.membersTitle': 'Topluluk Üyeleri',
  'backoffice.myCommunity.genealogyTreeSubtitle': 'Tam referans hiyerarşinizi keşfedin',
  'backoffice.myCommunity.treeViewSubtitle': 'Topluluğunuzun tablo görünümü',
  'backoffice.myCommunity.membersSubtitle': 'Tüm doğrudan ve dolaylı referanslarınızın listesi',

  'backoffice.myCommunity.username': 'Kullanıcı Adı',
  'backoffice.myCommunity.status': 'Durum',
  'backoffice.myCommunity.rank': 'Rütbe',
  'backoffice.myCommunity.level': 'Kademe',
  'backoffice.myCommunity.joinDate': 'Katılım Tarihi',
  'backoffice.myCommunity.country': 'Ülke',
  'backoffice.myCommunity.active': 'Aktif',
  'backoffice.myCommunity.inactive': 'Pasif',
  'backoffice.myCommunity.loading': 'Yükleniyor...',
  'backoffice.myCommunity.loadMore': 'Daha Fazla Yükle',
  'backoffice.myCommunity.expand': 'Genişlet',
  'backoffice.myCommunity.collapse': 'Daralt',
  'backoffice.myCommunity.resetView': 'Görünümü Sıfırla',
  'backoffice.myCommunity.memberSince': 'Üyelik başlangıcı',
  'backoffice.myCommunity.comingSoon': 'Yakında...',

  'backoffice.myCommunity.directReferrals': 'Doğrudan Referanslar',
  'backoffice.myCommunity.treeLevel': 'Ağaç Kademesi',
  'backoffice.myCommunity.zoomIn': 'Yakınlaştır',
  'backoffice.myCommunity.zoomOut': 'Uzaklaştır',
  
  'backoffice.myCommunity.totalUsers': 'Toplam Kullanıcılar',
  'backoffice.myCommunity.activeUsers': 'Aktif Kullanıcılar',
  'backoffice.myCommunity.inactiveUsers': 'Pasif Kullanıcılar',
  'backoffice.myCommunity.levelStats': 'Kademe {level} İstatistikleri',
  'backoffice.myCommunity.yourProfile': 'Profiliniz',
  'backoffice.myCommunity.communityMembers': 'Topluluk Üyeleri',
  
  'backoffice.myCommunity.filterByLevel': 'Kademeye Göre Filtrele',
  'backoffice.myCommunity.filterByStatus': 'Duruma Göre Filtrele',
  'backoffice.myCommunity.allLevels': 'Tüm Kademeler',
  'backoffice.myCommunity.allStatuses': 'Tüm Durumlar',
  
  'backoffice.myCommunity.noDataFound': 'Topluluk verisi bulunamadı',
  'backoffice.myCommunity.errorLoading': 'Topluluk verileri yüklenirken hata',
  'backoffice.myCommunity.tryAgain': 'Tekrar Dene',

  'backoffice.myCommunity.tableColumns.username': 'Kullanıcı Adı',
  'backoffice.myCommunity.tableColumns.name': 'Ad',
  'backoffice.myCommunity.tableColumns.status': 'Durum',
  'backoffice.myCommunity.tableColumns.rank': 'Rütbe',
  'backoffice.myCommunity.tableColumns.level': 'Kademe',
  'backoffice.myCommunity.tableColumns.joinDate': 'Katılım Tarihi',
  'backoffice.myCommunity.tableColumns.country': 'Ülke',
};
